var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_39123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8512 6.87202C22.2416 5.58417 21.4095 4.42247 20.4045 3.43599L11.9998 2.60869L3.59512 3.43603C3.56831 3.46233 3.54216 3.48924 3.51562 3.51581L6.87188 6.87206L11.9998 7.02867L22.8512 6.87202Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 20.4843C3.55978 20.5285 3.60384 20.5727 3.64866 20.6162L12 21.3913L20.3512 20.6162C21.3665 19.6318 22.2088 18.47 22.827 17.1802L7.30425 16.6957C5.96864 18.0313 4.42814 19.5717 3.51562 20.4843V20.4843Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8807 10.308L9.91309 9.91302L12.0001 12C11.3819 12.6181 10.4591 13.5409 9.91309 14.087L23.8734 13.7441C23.9564 13.1746 24.0001 12.5924 24.0001 12C24.0001 11.4256 23.9588 10.8609 23.8807 10.308V10.308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0C8.72671 0 5.76018 1.31109 3.59521 3.43603H20.4046C18.2396 1.31109 15.2731 0 11.9999 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3081 10.308H23.8807C23.7095 9.09496 23.3572 7.94024 22.8515 6.87201H6.87207L10.3081 10.308Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81982 17.1802H22.8271C23.3387 16.1127 23.6966 14.9579 23.8734 13.7441H10.2559C8.92521 15.0748 7.7975 16.2025 6.81982 17.1802Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 24C15.2465 24 18.1911 22.7104 20.3513 20.6161H3.64893C5.80911 22.7104 8.7538 24 12.0001 24Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28504 2.8094C4.01827 3.03356 3.76088 3.26854 3.51465 3.51468L12 12L3.51465 20.4853C3.76084 20.7315 4.01827 20.9664 4.28504 21.1906L13.4756 12L4.28504 2.8094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82467 8.86955L5.60162 11.2609H8.11623L6.08195 12.739L6.85895 15.1305L4.82467 13.6524L2.79034 15.1305L3.56744 12.739L1.5332 11.2609H4.04767L4.82467 8.86955Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96184 12.1957L4.93694 11.4783C4.93694 11.4783 4.78731 10.0747 4.77827 10.0271C4.70955 9.66511 4.39141 9.39131 4.00937 9.39131C3.57719 9.39131 3.22675 9.7417 3.22675 10.1739C3.22675 10.2456 3.2372 10.3147 3.25525 10.3807L2.6875 10.9522H3.697C3.697 12 2.91512 12 2.91512 13.0435L3.34886 14.087H5.95755L6.39236 13.0435H6.39217C6.43572 12.9434 6.46216 12.8401 6.47308 12.7369C6.84789 12.5853 6.96184 12.1957 6.96184 12.1957V12.1957Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_39123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.20a3186e4a0f61eda03b95581da67b15.svg";
export { ForwardRef as ReactComponent };